import React, { useMemo } from 'react';
import { T } from '@colonist/ui';
import { OpponentsCell } from './OpponentsCell/OpponentsCell.tsx';
import { ReplayCell } from './ReplayCell/ReplayCell.tsx';
import styles from './HistoryTableColumns.module.scss';
const HUG_CONTENT_WIDTH = '1%';
export const useHistoryTableColumns = ({ showReplayColumn, expandedGameIds, onReplayClick, onUsernameClick })=>useMemo(()=>{
        const columns = [
            {
                id: 'dateText',
                overflow: 'wrap',
                width: HUG_CONTENT_WIDTH,
                className: styles.dateColumn,
                header: ()=>/*#__PURE__*/ React.createElement(T, {
                        id: {
                            key: 'strings:profilePage.history.table.date.title'
                        }
                    }),
                cell: ({ value: dateText })=>/*#__PURE__*/ React.createElement(T, {
                        id: {
                            key: dateText.key,
                            options: {
                                ...dateText.options,
                                interpolation: {
                                    escapeValue: false
                                }
                            }
                        }
                    })
            },
            {
                id: 'rankText',
                overflow: 'nowrap',
                width: HUG_CONTENT_WIDTH,
                header: ()=>/*#__PURE__*/ React.createElement(T, {
                        id: {
                            key: 'strings:profilePage.history.table.rank.title'
                        }
                    })
            }
        ];
        columns.push({
            id: 'players',
            overflow: 'truncate',
            align: 'center',
            className: styles.opponentsColumn,
            header: ()=>/*#__PURE__*/ React.createElement(T, {
                    id: {
                        key: 'strings:profilePage.history.table.opponents.title'
                    }
                }),
            cell: ({ value: players, row })=>/*#__PURE__*/ React.createElement(OpponentsCell, {
                    players: players,
                    wrap: expandedGameIds.has(row.gameId),
                    onUsernameClick: onUsernameClick
                })
        });
        columns.push({
            id: 'durationText',
            overflow: 'nowrap',
            width: HUG_CONTENT_WIDTH,
            align: 'right',
            header: ()=>/*#__PURE__*/ React.createElement(T, {
                    id: {
                        key: 'strings:profilePage.history.table.duration.title'
                    }
                })
        });
        if (showReplayColumn) {
            columns.push({
                id: 'replayUrl',
                overflow: 'nowrap',
                width: HUG_CONTENT_WIDTH,
                align: 'center',
                header: ()=>/*#__PURE__*/ React.createElement(T, {
                        id: {
                            key: 'strings:profilePage.history.table.replay.title'
                        }
                    }),
                cell: ({ value: replayUrl, row })=>/*#__PURE__*/ React.createElement(ReplayCell, {
                        replayUrl: replayUrl,
                        gameId: row.gameId,
                        onReplayClick: onReplayClick
                    })
            });
        }
        return columns;
    }, [
        showReplayColumn,
        expandedGameIds,
        onReplayClick,
        onUsernameClick
    ]);
